import {Controller} from "@hotwired/stimulus"
import intervals from "../intervals"

class TimeoutController extends Controller {
  static targets = ["timer"]
  static values = {
    startingTime: Number,
    duration: Number
  }

  async connect() {
    this.interval = intervals.set(() => this.calc_time_left(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  calc_time_left() {
    if (!this.hasTimerTarget) return

    const now = Math.floor(Date.now() / 1000)
    const starting_time = this.startingTimeValue
    const elapsed_time = now - starting_time
    const remaining_time = Math.max(this.durationValue - elapsed_time, 0)
    const minutes = String(Math.floor(remaining_time / 60)).padStart(2, "0")
    const seconds = String(remaining_time % 60).padStart(2, "0")
    this.timerTarget.textContent = `${minutes}:${seconds}`
  }
}

export default TimeoutController
